import React, { useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';
import { Modal } from 'react-bootstrap'; // Import Bootstrap Modal
import { FaPhoneVolume } from 'react-icons/fa'; // Import Phone Icon
import { MdEmail } from 'react-icons/md'; // Import Email Icon
// আপনার প্রজেক্টের সঠিক পাথ অনুযায়ী এটি চেঞ্জ করতে পারেন
import ContactForm from './../../MainHeader/ContactForm';
import '../all/Main.css';

const Free = () => {
  const [isHovered, setIsHovered] = useState(false);
  
  // Modal State Management
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const x = useMotionValue(0);
  const y = useMotionValue(0);

  const springConfig = { stiffness: 150, damping: 15, mass: 0.1 };
  const animateX = useSpring(x, springConfig);
  const animateY = useSpring(y, springConfig);

  const handleMouse = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    x.set((event.clientX - centerX) * 0.25);
    y.set((event.clientY - centerY) * 0.25);
  };

  const resetMouse = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <div className="d-flex justify-content-lg-start justify-content-center align-items-center">
      <motion.div
        style={{ x: animateX, y: animateY }}
        onMouseMove={handleMouse}
        onMouseLeave={() => {
          resetMouse();
          setIsHovered(false);
        }}
        onMouseEnter={() => setIsHovered(true)}
      >
        <div style={{ position: 'relative', padding: '2px', borderRadius: '50px' }}>
          
          {/* Rotating Border */}
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 4, repeat: Infinity, ease: 'linear' }}
            style={{
              position: 'absolute',
              inset: '-2px',
              borderRadius: '50px',
              background: isHovered
                ? 'conic-gradient(from 0deg, transparent, #b22335, transparent)'
                : 'conic-gradient(from 0deg, transparent, rgba(178,35,53,0.25), transparent)',
              filter: 'blur(1px)',
              zIndex: 0,
            }}
          />

          {/* Glow */}
          <motion.div
            animate={{
              opacity: isHovered ? 0.45 : 0.15,
              scale: isHovered ? 1.04 : 1,
            }}
            transition={{ duration: 0.5 }}
            style={{
              position: 'absolute',
              inset: '-8px',
              borderRadius: '50px',
              background: '#b22335',
              filter: 'blur(18px)',
              zIndex: 0,
            }}
          />

          {/* Button */}
          <motion.button
            className="btn position-relative overflow-hidden"
            onClick={handleShow} // Click করলে Modal ওপেন হবে
            style={{
              background: '#ffffff',
              border: 'none',
              borderRadius: '50px',
              padding: '10px 24px',
              cursor: 'pointer',
              zIndex: 1,
              boxShadow: `0 0 20px rgba(178, 35, 53, ${
                isHovered ? 0.18 : 0.08
              })`,
              transition: 'all 0.4s ease',
            }}
            whileTap={{ scale: 0.96 }}
          >
            {/* Shine Sweep */}
            <motion.div
              style={{
                position: 'absolute',
                top: 0,
                left: '-100%',
                width: '100%',
                height: '100%',
                background:
                  'linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent)',
                zIndex: 1,
              }}
              animate={{ left: isHovered ? '100%' : '-100%' }}
              transition={{ duration: 0.8 }}
            />

            {/* Content */}
            <div
              className="d-flex align-items-center gap-2 position-relative"
              style={{ zIndex: 2 }}
            >
              <motion.div
                animate={{
                  scale: isHovered ? [1, 1.25, 1] : 1,
                }}
                transition={{
                  duration: 1,
                  repeat: isHovered ? Infinity : 0,
                }}
                style={{
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  background: '#b22335',
                  flexShrink: 0,
                }}
              />

              <motion.span
                animate={{
                  letterSpacing: isHovered ? '0.8px' : '0.3px',
                  color: '#2b4d8d',
                }}
                transition={{ duration: 0.35 }}
                style={{
                  fontFamily: "'hauora-medium', sans-serif",
                  fontWeight: 700,
                  fontSize: '15px',
                }}
                className="free-btn-text"
              >
                Free Roof Inspection
              </motion.span>
            </div>
          </motion.button>
        </div>
      </motion.div>

      {/* Modal Element */}
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        className="modalpopup d-flex justify-content-center"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fontHauora">
            Get Your Free Estimate
          </Modal.Title>
        </Modal.Header>

        <div className="mx-auto justify-content-center my-2">
          <div className="mx-2 px-md-1 px-2 text-center mb-0 pb-0">
            <p className="text-center fontHauora mb-1">
              Please call and email us with your Details
            </p>

            <div className="my-0">
              <p className="my-0 py-0 fontLight">
                <FaPhoneVolume className="phone-icon ms-1 me-1" />
                <span className="phone-number fontLight">
                  614-357-7539
                </span>
              </p>

              <p className="d-flex align-items-center gap-1 text-center justify-content-center fontLight pb-0 mb-0">
                <MdEmail className="color" />
                <span className="fontLight">
                  roofs@ultimatesroofing.com
                </span>
              </p>
            </div>
          </div>

          <p className="px-2 d-flex justify-content-center mx-auto text-center fontLight my-0 py-0">
            OR
          </p>

          <p className="mx-2 text-center fontLight my-0 py-0">
            Leave your Information below
          </p>
        </div>

        <Modal.Body className="contact-modal-body mx-auto d-flex justify-content-center">
          <ContactForm handleClose={handleClose} />
        </Modal.Body>
      </Modal>

      {/* Responsive Styles */}
      <style>
        {`
          @media (max-width: 768px) {
            .free-btn-text {
              font-size: 13px !important;
            }

            .btn {
              padding: 8px 18px !important;
            }
          }

          @media (max-width: 576px) {
            .free-btn-text {
              font-size: 12px !important;
            }

            .btn {
              padding: 7px 16px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Free;